/**
 * Helper functions for environment analytics tracking
 */
/**
 * Time conversion constants for analytics calculations
 */
export const TIME_CONSTANTS = {
    MS_PER_MINUTE: 60000,
    MS_PER_HOUR: 3600000,
    SECONDS_PER_HOUR: 3600,
    SECONDS_PER_DAY: 86400,
};
/**
 * Calculate the age of an environment in hours since its creation
 * @param createdAt ISO timestamp of environment creation
 * @returns Age in hours (decimal)
 */
export const getEnvironmentAgeHours = (createdAt) => {
    const environmentAgeMs = Date.now() - new Date(createdAt).getTime();
    const environmentAgeHours = environmentAgeMs / TIME_CONSTANTS.MS_PER_HOUR; // Convert ms to hours
    return environmentAgeHours;
};
